export const RED0 = '#B20027';
export const RED1 = '#FC0137';
export const RED2 = '#FEA1B6';

export const BLUE0 = '#3a5d80';
export const BLUE = '#74B9FF';
export const BLUE1 = '#acd5ff';
export const BLUE2 = '#e3f1ff';
export const BLACK = '#000000';
export const BLACK1 = '#00000014';
export const WHITE = '#FFFFFF';

export const YELLOW = '#D4A900';
export const YELLOW0 = '#8C6A00';
export const YELLOW1 = '#FFD54F';
export const YELLOW2 = '#FFF3B0';
export const YELLOW3 = '#FFF9DB';

export const GREY = '#666666';
export const GREY1 = '#eeeeee';
export const GREY2 = '#f5f5f5';

export const GREEN = '#11c446';

interface IssueColorsType {
  internal_issue: { bg: string; text: string };
  external_issue: { bg: string; text: string };
  private_issue: { bg: string; text: string };
}

export type IssueColorKeys = keyof IssueColorsType;

export const ISSUE_COLORS: IssueColorsType = {
  internal_issue: { bg: 'rgb(236,242,255)', text: 'rgb(93, 135, 255)' },
  external_issue: { bg: 'rgb(215,252,223)', text: 'rgb(36, 134, 51)' },
  private_issue: { bg: 'rgba(131, 52, 113, 0.2)', text: 'rgba(131, 52, 113,1.0)' },
};
